import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';

function ProjectList() {
  const { keycloak } = useKeycloak();
  const [projects, setProjects] = useState([]);
  const [filteredStatus, setFilteredStatus] = useState('Tous');
  const navigate = useNavigate();

  const handleEdit = (id) => {
    navigate(`/wizard?edit=true&id=${id}`);
  };

  const handleFilterChange = (status) => {
    setFilteredStatus(status);
  };

  useEffect(() => {
    const headers = keycloak?.token
      ? { Authorization: `Bearer ${keycloak.token}` }
      : {};
    fetch('https://weavevo.com/projects', { headers })
      .then(res => res.json())
      .then(data => setProjects(data));
  }, [keycloak]);

  const filteredProjects = filteredStatus === 'Tous'
    ? projects
    : projects.filter(p => p.status === filteredStatus);

  return (
    <div className="container py-5">
      <h2 className="text-center mb-4 display-6 text-primary">
        🎥 Mes Projets Documentaires
      </h2>

      {/* Filtres */}
      <div className="d-flex justify-content-center gap-3 flex-wrap mb-4">
        {['Tous', 'Draft', 'Active', 'Clôturé'].map(status => (
          <button
            key={status}
            onClick={() => handleFilterChange(status)}
            className={`btn rounded-pill px-4 py-1 shadow-sm fw-medium ${
              filteredStatus === status
                ? 'btn-primary text-white'
                : 'btn-outline-primary'
            }`}
          >
            {status === 'Tous' && '📂 Tous'}
            {status === 'Draft' && '📝 Draft'}
            {status === 'Active' && '🚀 Active'}
            {status === 'Clôturé' && '✅ Clôturé'}
          </button>
        ))}
      </div>

      {filteredProjects.length === 0 ? (
        <p className="text-center text-muted">Aucun projet trouvé pour ce filtre.</p>
      ) : (
        <div className="row g-4">
          {filteredProjects.map(project => (
            <div className="col-md-6 col-lg-4" key={project.id}>
              <div className="card shadow-sm border-0 h-100 rounded-4 p-4 bg-light position-relative">
                <div className="d-flex justify-content-between align-items-start mb-2">
                  <h5 className="text-dark mb-0 text-truncate" title={project.title}>
                    {project.title}
                  </h5>
                  <span className={`badge rounded-pill px-3 py-1 fw-semibold
                    ${project.status === 'Draft' ? 'bg-warning text-dark' :
                      project.status === 'Active' ? 'bg-primary text-white' :
                        project.status === 'Clôturé' ? 'bg-success text-white' : 'bg-secondary'}`}>
                    {project.status === 'Draft' && '📝 Draft'}
                    {project.status === 'Active' && '🚀 Active'}
                    {project.status === 'Clôturé' && '✅ Clôturé'}
                  </span>
                </div>

                <p className="text-muted small">{project.description}</p>

                <div className="d-flex justify-content-between align-items-center mt-auto pt-2">
                  <button
                    className="btn btn-outline-primary btn-sm px-3 py-1 rounded-pill"
                    onClick={() => handleEdit(project.id)}
                  >
                    ✏️ Modifier
                  </button>
                  <button
                    className="btn btn-outline-info btn-sm px-3 py-1 rounded-pill"
                    onClick={() => window.open(`/project/${project.id}/manage`, '_blank')}
                  >
                    👁️ Suivre
                  </button>
                  <span className="text-muted small">
                    📅 {new Date(project.created_at).toLocaleDateString()}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ProjectList;
